import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=32dce3b6&"
import script from "./Provider.vue?vue&type=script&lang=js&"
export * from "./Provider.vue?vue&type=script&lang=js&"
import style0 from "./Provider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Provider.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Provider.vue
// module id = 2424
// module chunks = 1